var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd20-tag",class:_vm.classes,style:(_vm.styles)},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }